// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6079) return "static/chunks/6079.12083a5583cbf255.js";
	if (chunkId === 7082) return "static/chunks/7082.4b4fb22461c75c2b.js";
	if (chunkId === 1388) return "static/chunks/1388.33250c6b6c3debee.js";
	if (chunkId === 1500) return "static/chunks/1500.08ed13a96eca80c4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"171":"3b59fb38","3205":"8b0ab663","6593":"framework","7004":"f5483a8d","7298":"9c68d964"}[chunkId] || chunkId) + "-" + {"171":"27497029f4bd096f","1143":"b12bc7f3088d6030","3205":"99d4b3584cb379e3","5501":"e89de708b7aad6ab","6593":"f0486a883f1a3882","7004":"f9cf621d7127d34b","7298":"fe4d8b4cad1037c2","7842":"f8d767f6d24459bf"}[chunkId] + ".js";
};